enum FeaturedListMatchCriteriaType {
  NONE = "NONE",
  GENERIC = "GENERIC",
  FIELD_MAPPING = "FIELD_MAPPING"
}

export default FeaturedListMatchCriteriaType;
